import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import StatusCard from './StatusCard';
// import SectionHeader from './SectionHeader';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { useLanguage } from '../../../contexts/LanguageContext';
import { 
  UnderReviewIcon, 
  RefundedIcon, 
  ForProcurementIcon, 
  PaymentUnverifiedIcon 
} from '../../../components/icons/DashboardIcons';

const CancelledItemsSection: React.FC = () => {
  const { stats } = useDashboardStore();
  const { t } = useLanguage();

  const getStatusValue = (statusKey: string): string => {
    const value = stats?.status_counts?.[statusKey];
    return value !== undefined ? value.toString() : '0';
  };

  const cancelledCards = useMemo(() => [
    {
      title: t('dashboard.underReview'),
      value: getStatusValue('under-review'),
      change: '+2%',
      changeType: 'increase' as const,
      icon: UnderReviewIcon,
      color: 'purple',
      navigateTo: '/orders?tab=under_review'
    },
    {
      title: t('dashboard.refunded'),
      value: getStatusValue('refunded'),
      change: '+60%',
      changeType: 'increase' as const,
      icon: RefundedIcon,
      color: 'orange',
      navigateTo: '/orders?tab=refunded'
    },
    {
      title: t('dashboard.partialFulfillment'),
      value: getStatusValue('partial-fulfillment'),
      change: '+0%',
      changeType: 'increase' as const,
      icon: ForProcurementIcon,
      color: 'blue',
      navigateTo: '/orders?tab=partial_fulfillment'
    },
    {
      title: t('dashboard.notEligibleForRefund'),
      value: getStatusValue('not-eligilbe-refund'),
      change: '+35%',
      changeType: 'increase' as const,
      icon: PaymentUnverifiedIcon,
      color: 'orange',
      navigateTo: '/orders?tab=not_eligible_refund'
    }
  ], [stats, t]);

  return (
    <div>
      {/* Section with background covering title and controls */}
      <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
        {/* Section Header with Week button */}
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.cancelledItems')}</h2>
          <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
            <SlidersHorizontal size={14} />
            {t('common.week')}
          </button>
        </div>
        
        {/* Cards in 2x2 grid */}
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {cancelledCards.map((card, index) => (
            <StatusCard key={index} card={card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CancelledItemsSection;